module.exports = __webpack_public_path__ + "img/user-avatar-stub.499dda55.svg";